import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { UtilsService } from '@app/services/services.module';

@Component({
  selector: 'app-recognition-modal',
  templateUrl: './recognition-modal.component.html',
  styleUrls: ['./recognition-modal.component.scss']
})
export class RecognitionModalComponent implements OnInit {
  @ViewChild('inputService') inputService: any;
  @ViewChild('inputOwnStaff') inputOwnStaff: any;
  @ViewChild('inputExternalStaff') inputExternalStaff: any;

  @Input() projectName: string;
  @Input() year: string;
  @Input() month: string;
  @Input() service: any;
  @Input() ownStaff: any;
  @Input() externalStaff: any;
  @Output() actionCloseModal: EventEmitter<any> = new EventEmitter();
  @Output() actionAccept: EventEmitter<any> = new EventEmitter();

  public disabled = true;
  private cache = {
    service: String((0).toFixed(2)),
    ownStaff: String((0).toFixed(2)),
    externalStaff: String((0).toFixed(2))
  };

  constructor(
    private readonly utilsService: UtilsService
  ) {}

  ngOnInit() {
    if (!this.service) {
      this.service = String((0).toFixed(2));
    }
    if (!this.ownStaff) {
      this.ownStaff = String((0).toFixed(2));
    }
    if (!this.externalStaff) {
      this.externalStaff = String((0).toFixed(2));
    }

    this.cache.service = parseFloat(this.service).toFixed(2);
    this.cache.ownStaff = parseFloat(this.ownStaff).toFixed(2);
    this.cache.externalStaff = parseFloat(this.externalStaff).toFixed(2);
  }

  get disabledAcceptButton(): boolean {
    return  this.cache.ownStaff === this.ownStaff &&
      this.cache.service === this.service &&
      this.cache.externalStaff === this.externalStaff;
  }

  /**
   * Set external personal value
   * @param value number of external personal cost
   */
  setExternalPersonal(value: any) {
    value = this.utilsService.cleanInputNumber(value);
    this.externalStaff = value;
    this.inputExternalStaff.nativeElement.value = value;
  }
  /**
   * Set service value
   * @param value number of service cost
   */
  setServices(value: any) {
    value = this.utilsService.cleanInputNumber(value);
    this.service = value;
    this.inputService.nativeElement.value = value;
  }
  /**
   * Set ownPerson value
   * @param value number of ownPerson cost
   */
  setOwnStaff(value: any) {
    value = this.utilsService.cleanInputNumber(value);
    this.ownStaff = value;
    this.inputOwnStaff.nativeElement.value = value;
  }

  /**
   * Emits the values of modal
   */
  acceptOperation(): void {
    const value = {
      service: this.service,
      ownStaff: this.ownStaff,
      externalStaff: this.externalStaff
    };

    this.actionAccept.emit(value);
  }

  /**
   *
   * @returns number as string of sum
   */
  get total(): string {
    const result = Number(this.ownStaff) + Number(this.externalStaff) + Number(this.service);
    return result.toFixed(2);
  }

  /**
   * Emits the order to close modal
   */
  closeModal(): void {
    this.actionCloseModal.emit();
  }
}
